export { riotReduxConnect as default } from './src/define-mixin.js';
